import { useContext, useEffect } from 'react';
import { AppContext } from '../contexts/AppContext';
import { useNavigate } from 'react-router-dom';

function PrivateRoute({ children }) {
    const { isLoggedIn } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/logout');
        }
    }, [isLoggedIn, navigate])

    // Don't render children if not logged in
    if (!isLoggedIn) {
        return null;
    }

    return children
}

export default PrivateRoute;